"use client";
import React, { useEffect, useState } from "react";
import $ from "jquery";

import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";
import { ModalVideo } from "@sendmagic/prismic-nextjs/src/components/utils/ModalVideo";
import Button from "@stadium/ui/src/components/button/button";

import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";
import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

import defaultStyles from "./main.module.scss";

const AnimationDelay = 2000;

const fadeEffectAnimation = (speedOfEffect, selector) => {
  const images = document.querySelectorAll(selector);
  const imageCount = images.length;
  let position = 0;

  const animate = () => {
    $(images[position]).fadeOut(speedOfEffect);
    position = (position + 1) % imageCount;
    $(images[position]).fadeIn(speedOfEffect);
  };
  animate();
  const interval = setInterval(() => {
    animate();
  }, speedOfEffect + AnimationDelay);
  return interval;
};

const AnimatedHeroBanner = ({ doc, sliceStyles: styles = defaultStyles }) => {
  const {
    heading,
    description,
    cta_text,
    cta_link,
    second_cta_text,
    second_cta_link,
    bg_color,
    speed,
    video_embeded_text,
    video,
  } = doc?.primary || {};
  const sectionStyleBg = { backgroundColor: bg_color };
  const [images] = useState(() =>
    doc?.items?.map(({ image, mobile_image }) => ({
      url: image.url,
      alt: image.alt,
      mobileUrl: mobile_image.url,
      mobileAlt: mobile_image.alt,
    })),
  );
  const [selectedVid, setSelectedVid] = useState("");

  const animatedHeroImagesClass = styles.animatedHeroBannerImages;

  useEffect(() => {
    let interval;
    const t = setTimeout(() => {
      const speedOfEffect = speed * 1000;
      interval = fadeEffectAnimation(speedOfEffect, `.${animatedHeroImagesClass}`);
    }, 10000);
    return () => {
      clearTimeout(t);
      clearInterval(interval);
    };
  }, []);

  const closeModal = () => setSelectedVid("");

  return (
    <>
      <div className={styles.animatedHeroBannerSlice} style={sectionStyleBg}>
        <div className={styles.animatedHeroBannerImagesHolder}>
          {images?.map((image, index) => (
            <picture
              style={{ display: index === 0 ? "block" : "none" }}
              className={animatedHeroImagesClass}
              key={image.url}
            >
              <source
                media="(max-width: 767px)"
                srcSet={image.mobileUrl}
                height={1646}
                width={977}
              />
              <source media="(min-width: 768px)" srcSet={image.url} height={768} width={1440} />
              <img src={image.url} alt={image.alt} fetchPriority={index === 0 ? "high" : "low"} />
            </picture>
          ))}
        </div>
        <div className={styles.animatedHeroBannerContentSection}>
          <div className={styles.backgroundImageTextSliceContainer}>
            {checkContentPresence(heading) && (
              <h1 className={styles.backgroundImageTextSliceTitle}>
                {textResolver(heading, { convertLabelToModular: true, convertToNormalText: true })}
              </h1>
            )}
            {checkContentPresence(description) && (
              <div className={styles.backgroundImageTextSliceDescription}>
                {textResolver(description, { convertLabelToModular: true })}
              </div>
            )}
            {(checkContentPresence(cta_text) || checkContentPresence(second_cta_text)) && (
              <>
                <div className={styles.backgroundImageTextSliceBtnsRow}>
                  {checkContentPresence(cta_text) && (
                    <PrismicLinkTag
                      url={cta_link?.url}
                      urlText={cta_text}
                      target={cta_link?.target}
                      className={styles.backgroundImageTextSliceCta}
                      data-testid="first-cta"
                      convertLabelToModular
                    />
                  )}

                  {checkContentPresence(second_cta_text) && (
                    <PrismicLinkTag
                      url={second_cta_link?.url}
                      urlText={second_cta_text}
                      target={second_cta_link?.target}
                      className={styles.backgroundImageTextSliceCta}
                      data-testid="second-cta"
                      convertLabelToModular
                    />
                  )}
                </div>
                <div className={styles.animatedHeroBannerTextLinkRow}>
                  {checkContentPresence(video_embeded_text) && (
                    <Button
                      onClick={() => setSelectedVid(video)}
                      customClass={styles.animatedHeroBannerLinkButton}
                    >
                      {textResolver(video_embeded_text, { convertLabelToModular: true })}
                    </Button>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {selectedVid && <ModalVideo video={selectedVid} closeModal={closeModal} />}
    </>
  );
};

export default AnimatedHeroBanner;
